// extracted by css-extract-rspack-plugin
export default {"description":"_666b78ca"};